import { Component, useState} from "react";
import BaseModal from "../Base-modal";

const Content = ({closeModal, showModal}) => {
    
    return (
        <>
            <div style={{'direction': 'rtl', 'display': 'flex', 'justifyContent': 'center', 'marginBottom': '10px'}}>
                <h2>Refund Terms And Conditions</h2>
            </div>
            <div style={{'direction': 'rtl', 'display': 'flex', 'gap': '10px', 'flexDirection': 'column', 'textAlign': 'justify', 'fontFamily': 'sans-serif'}}>
                <p style={{'lineHeight': '2'}}>درج مبلغ صحیح استردادی (خصوصا در بلیتهای exchange شده) بر عهده رییس دفتر فروش مربوطه می باشد.</p>
                <p style={{'lineHeight': '2'}}>استرداد وجه به شبای حساب مسافر یا بستگان درجه یک و وکیل قانونی مجاز می باشد در غیر اینصورت ارائه مدارک اثبات پرداخت توسط سایر افراد، جهت واریز وجه استرداد به حساب پرداخت کننده الزامی می باشد.</p>
                <p style={{'lineHeight': '2'}}>استرداد در وجه یکی از مسافران از یک PNR مشترک مجاز می باشد.</p>
                <p style={{'lineHeight': '2'}}>عدم کتنرل دفتر صادر کننده در ارسال مکرر (دوبل) بلیت استردادی طی جداول مختلف که منجر به پرداخت تکراری گردد در تعهد رئیس دفتر مربوطه قرار خواهد گرفت.</p>
                <p style={{'lineHeight': '2'}}>عدم پذیرش مستندات پرداخت در وجه افراد توسط واحد رسیدگی و کنترل مالی موجب صدور بدهکاری در حساب رئیس دفتر فروش مربوطه خواهد شد.</p>
            </div>
        </>
    )


}


class TermModal extends Component {
    state = {
        open: false,
        inputs: {}
    }

    openModal = () => this.setState({open: true})
    closeModal = () => this.setState({open: false})

    render() {
        return (
            <BaseModal open={this.state.open} closeModal={this.closeModal}>
                <Content
                    {...this.props}
                    showModal={this.state.open}
                    closeModal={this.closeModal}
                />
            </BaseModal>
        )
    }
}

export default TermModal